// HOW-SLOTS-WEB-AGENDA-TASKS (2026-07-09): the resilience gate (plan section 4c). `checked` flips
// true once the /v1/capabilities call has settled (success OR failure); `agenda`/`tasks` are only
// ever true when the backend explicitly said so -- an unreachable/erroring call leaves both false,
// which is the same "not shown" state as a tenant with the feature genuinely off. Components gate
// on `checked && agenda` / `checked && tasks` (never render before the check settles, never render
// on a guess).
import actionTypes from "@actions/actionTypes"

export const initialState = {
  checking: false,
  checked: false,
  agenda: false,
  tasks: false,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.CAPABILITIES_CHECKING:
      return { ...state, checking: true }
    case actionTypes.CAPABILITIES_SET:
      return {
        ...state,
        checking: false,
        checked: true,
        agenda: !!action.payload?.agenda,
        tasks: !!action.payload?.tasks,
      }
    default:
      return state
  }
}
